module.exports = __webpack_public_path__ + "static/media/img_banner_download_app.1e2c5e2a.jpeg";